/* unplugin-vue-components disabled */import script from "./CompanyInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyInfo.vue?vue&type=style&index=0&id=59105668&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59105668"]])

export default __exports__